import { Popover, Tag } from "antd";
import dayjs from "dayjs";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_DISPLAY_SETTING } from "@assets/svgs/ICON_DISPLAY_SETTING.svg";
import { ReactComponent as ICON_EYE } from "@assets/svgs/ICON_EYE.svg";
import { ReactComponent as ICON_MEDIA_INFO } from "@assets/svgs/ICON_MEDIA_INFO.svg";
import { ReactComponent as ICON_PREVIEW } from "@assets/svgs/ICON_PREVIEW.svg";
import { ReactComponent as ICON_RESTART } from "@assets/svgs/ICON_RESTART.svg";
import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Text } from "@components/Text";
import { ContentInfo } from "@pages/CampaignListPage/ContentInfo";
import { COLOR_DARK_GREY } from "@static/COLORS";
import {
  KEY_CAMPAIGNS_UPDATE,
  KEY_CAMPAIGNS_DELETE,
  KEY_CAMPAIGNS_ADD,
} from "@static/PERMISSION_KEY";

const SectionTableAction = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BASE_CAMPAIGN_LIST_TABLE_COLUMNS = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    fixed: "left",
    width: 80,
    sorter: (a, b) => a.index - b.index,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    fixed: "left",
    width: 280,
  },
  {
    title: "Total Duration (Sec)",
    dataIndex: "totalDuration",
    key: "totalDuration",
    align: "center",
    width: 120,
    render: (text, item, index) => {
      const maxDuration = _.chain(item)
        .get(["adsBlocks"])
        .map((adsBlockItem) => {
          const filterBlockMedias = _.chain(adsBlockItem)
            .get(["blockMedias"])
            .filter((filterBlockMediaItem) => {
              const endDate = _.get(filterBlockMediaItem, "end_date");
              return !dayjs(endDate).isBefore(dayjs());
            })
            .value();
          return { ...adsBlockItem, blockMedias: filterBlockMedias };
        })
        .map((item) => {
          const blockMedias = _.get(item, ["blockMedias"]);
          const totalDuration = _.sumBy(blockMedias, (media) => {
            const duration = _.get(media, "duration", 0);
            const repeat = _.get(media, "repeat", 1);
            return duration * repeat;
          });

          return totalDuration;
        })
        .max()
        .value();

      return <Text align="center">{maxDuration}</Text>;
    },
  },
  {
    title: "Details",
    key: "details",
    align: "center",
    width: 120,

    render: (text, item, index) => {
      return (
        <Popover
          content={<ContentInfo key={index} data={item} />}
          title="Details"
          trigger="click"
        >
          <ICON_MEDIA_INFO
            style={{ cursor: "pointer" }}
            fill={COLOR_DARK_GREY}
            width={"20px"}
            height={"20px"}
          />
        </Popover>
      );
    },
  },
  {
    title: "Status",
    key: "status",
    align: "center",
    width: 100,
    render: (text, item) => {
      const MAP_STATUS = { "ON-AIR": "ON AIR", DRAFT: "DRAFT" };
      const rawStatus = _.get(item, ["status"]);

      let color;

      switch (rawStatus) {
        case "ON-AIR":
          color = "success";
          break;
        case "DRAFT":
          color = "error";
          break;
        default:
          color = "default";
      }
      return <Tag color={color}>{_.get(MAP_STATUS, [rawStatus])}</Tag>;
    },
  },
];

export const getCampaignListTableColumns = ({
  isWithKios,
  permission,
  onHandleEdit,
  onHandleDelete,
  onHandleRedirect,
  onHandlePreview,
  showConfirmation,
  handleKiosUpdateContent,
}) => {
  console.log("isWithKios :>> ", isWithKios);
  const campaignListColumns = [...BASE_CAMPAIGN_LIST_TABLE_COLUMNS];

  return [
    ...campaignListColumns,
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (text, item, index) => {
        return (
          // isWithKios
          <SectionTableAction key={index}>
            {/* <Icon
              isCursor
              width={18}
              height={18}
              onClick={() => onHandlePreview({ item })}
            >
              <ICON_PREVIEW />
            </Icon> */}

            {isWithKios && (
              <>
                <Popover
                  placement="top"
                  trigger="hover"
                  content={<div>Key : {item?.id}</div>}
                >
                  <ICON_EYE width={24} height={24} />
                </Popover>
                <Popover
                  placement="top"
                  trigger="hover"
                  content={<div>Update Content</div>}
                >
                  <ICON_RESTART
                    width={24}
                    height={24}
                    onClick={() => handleKiosUpdateContent({ item })}
                  />
                </Popover>
              </>
            )}

            <Popover
              placement="top"
              trigger="hover"
              content={<div>Preview</div>}
            >
              <ICON_PREVIEW
                width={18}
                height={18}
                // onClick={() => onHandlePreview({ item })}
                onClick={() =>
                  showConfirmation({
                    title: "Go to preview",
                    onConfirm: () => onHandlePreview({ item }),
                  })
                }
              />
            </Popover>
            {_.includes(permission, KEY_CAMPAIGNS_ADD) && (
              // <Icon
              //   isCursor
              //   width={20}
              //   height={20}
              //   onClick={() => onHandleRedirect({ item })}
              // >
              //   <ICON_DISPLAY_SETTING />
              // </Icon>
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Go to campaign block</div>}
              >
                <ICON_DISPLAY_SETTING
                  width={20}
                  height={20}
                  // onClick={() => onHandleRedirect({ item })}
                  onClick={() =>
                    showConfirmation({
                      title: "Go to campaign block",
                      onConfirm: () => onHandleRedirect({ item }),
                    })
                  }
                />
              </Popover>
            )}
            {_.includes(permission, KEY_CAMPAIGNS_UPDATE) && (
              // <Icon
              //   isCursor
              //   width={24}
              //   height={24}
              //   onClick={() => onHandleEdit({ item })}
              // >
              //   <ICON_TABLE_EDIT />
              // </Icon>
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Edit</div>}
              >
                <ICON_TABLE_EDIT
                  width={24}
                  height={24}
                  onClick={() => onHandleEdit({ item })}
                />
              </Popover>
            )}
            {_.includes(permission, KEY_CAMPAIGNS_DELETE) && (
              // <Icon
              //   isCursor
              //   width={24}
              //   height={24}
              //   onClick={() =>
              //     showConfirmation({
              //       onConfirm: () => onHandleDelete({ item }),
              //     })
              //   }
              // >
              //   <ICON_TABLE_DELETE />
              // </Icon>
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Delete</div>}
              >
                <ICON_TABLE_DELETE
                  width={24}
                  height={24}
                  onClick={() =>
                    showConfirmation({
                      title: "Delete",
                      onConfirm: () => onHandleDelete({ item }),
                    })
                  }
                />
              </Popover>
            )}
          </SectionTableAction>
        );
      },
    },
  ];
};
